import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import { ROUTER } from '@/router/constants';
import { SNACKBAR_STATUS } from '@/constants/constants';
import { RUNNITS_OWNER_SELECTION } from '@/views/Runnits/constants';
import { boardsV2Access, BoardsV2Access } from '@/utils/boardsVersion';

// Whether the account being acted as has Boards v2 (the rollout's rule is in
// boardsV2Access). Live: it follows the account picker, and a person, team or
// company turned on or off on the Boards v2 Rollout admin page.
export const BoardsV2AccessMixin = Vue.extend({
	computed: {
		...mapState([
			'user',
			'team',
			'runnitState',
		]),
		boardsV2Access (): BoardsV2Access {
			return boardsV2Access(
				this.user,
				this.team,
				this.runnitState.runnitsOwnerSelection === RUNNITS_OWNER_SELECTION.TEAM,
			);
		},
	},
	methods: {
		...mapActions([
			'updateSnackbar',
		]),
		// Sends an account without Boards v2 to the classic list, saying why
		leaveBoardsV2 () {
			const teamName: string | null = this.runnitState.runnitsOwnerSelection === RUNNITS_OWNER_SELECTION.TEAM && this.team
				? this.team.name
				: null;
			this.updateSnackbar({
				status: SNACKBAR_STATUS.INFO,
				message: teamName
					? `Boards v2 isn't on for ${teamName} yet`
					: 'Boards v2 isn\'t on for your personal account yet',
				show: true,
			});
			this.$router.replace({ name: ROUTER.RUNNIT_BOARDS_PAGE }).catch(() => {});
		},
	},
});
